export default __webpack_public_path__ + "static/media/cl.44f73af0.jpg";